import * as React from "react";
import { Configure, Index, useSortBy, useSearchBox, useRefinementList, useRange } from "react-instantsearch";
import { FacetId } from "../../../../../../types.js";
import { useAlgoliaConfig } from "../../../../../Algolia/AlgoliaConfig.js";
const VirtualSortBy = ({ items }) => {
  const parsedItems = React.useMemo(
    () => items.map((item) => ({ value: item.value, label: item.labelKey })),
    [items]
  );
  useSortBy({ items: parsedItems });
  return null;
};
const VirtualRefinementList = ({ attribute, limit }) => {
  useRefinementList({ attribute, limit });
  return null;
};
const VirtualRange = ({ attribute }) => {
  useRange({ attribute });
  return null;
};
const VirtualSearchBox = () => {
  useSearchBox();
  return null;
};
const VirtualFacets = () => {
  const {
    locale,
    facets,
    sortIndices,
    filters,
    ruleContexts,
    facetingAfterDistinct,
    indexes,
    isMultilingualEnabled,
    clientQueryString
  } = useAlgoliaConfig();
  const localeFilter = `locale:${locale.replace("-", "_")}`;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Configure,
    {
      clickAnalytics: true,
      facetingAfterDistinct,
      filters,
      ruleContexts
    }
  ), sortIndices.length > 0 ? /* @__PURE__ */ React.createElement(VirtualSortBy, { items: sortIndices }) : null, indexes && indexes.length > 0 ? indexes.map((index) => {
    const rawQuery = new URLSearchParams(clientQueryString?.split("?")[1]);
    const query = rawQuery.get("q") ?? void 0;
    return /* @__PURE__ */ React.createElement(Index, { indexName: index.name, key: index.name }, /* @__PURE__ */ React.createElement(
      Configure,
      {
        filters: isMultilingualEnabled ? localeFilter : void 0,
        ruleContexts,
        query
      }
    ));
  }) : null, sortIndices.length > 0 ? /* @__PURE__ */ React.createElement(VirtualSortBy, { items: sortIndices }) : null, /* @__PURE__ */ React.createElement(VirtualSearchBox, null), facets.map((facet) => {
    switch (facet.id) {
      case FacetId.price:
        return /* @__PURE__ */ React.createElement(VirtualRange, { key: facet.attribute, attribute: facet.attribute });
      default:
        return /* @__PURE__ */ React.createElement(
          VirtualRefinementList,
          {
            key: facet.attribute,
            attribute: facet.attribute,
            limit: 100
          }
        );
    }
  }));
};
export {
  VirtualFacets
};
//# sourceMappingURL=VirtualFacets.js.map
